import PerfectScrollbar from 'perfect-scrollbar';

export class WpetMapCpnt {
    constructor()
    {
        this.initializeGeoloc();
        this.initializeFilters();
    }
    
    initializeGeoloc()
    {
        if ( $( '.page-templates-interactive-map' ).length > 0 ) {
        
            // Scroll bar filter
            const ps      = new PerfectScrollbar( '.interactiveMapFilterEngine' ),
                  trigger = document.getElementById( 'wpet_center_position' );
        
            // Position user
            trigger.addEventListener( 'click', () => {
                getUserPosition();
                return false;
            } );
        
            let getUserPosition = () => {
            
                if ( navigator.geolocation ) {
                
                    let position = navigator.geolocation.getCurrentPosition( positionSuccess, null, {
                        enableHighAccuracy: true,
                        timeout: 5000,
                        maximumAge: 10
                    } );
                }
            };
        
            // Callback pour la récupération de la position d'un utiliateur
            let positionSuccess = ( position ) => {
            
                if ( typeof position.coords != 'undefined' ) {
                    if ( typeof position.coords.latitude != 'undefined' ) {
                        let newCenter = new window.wpet_map_object.mapAdapter.LatLng( position.coords.latitude, position.coords.longitude );
                        window.wpet_map_object.mapObject.setCenter( newCenter );
                    
                        //url de l'icone
                        let icon = Theme.themeURL + '/assets/dist/images/markers/center.svg';
                    
                        //Ajout du marqueur
                        let marker = new window.wpet_map_object.mapAdapter.Marker( newCenter, window.wpet_map_object.map, icon );
                    
                        //Infobulle
                        let htlmContent = '<p class="wpetLeafletCenterText text-center">' + Theme.translate.here + '</p>';
                        marker.setInfoWindow( htlmContent );
                    
                        window.wpet_map_object.markers.push( marker );
                        window.wpet_map_object.markercluster = new window.wpet_map_object.mapAdapter.MarkerCluster( window.wpet_map_object.markers );
                    }
                }
            };
        }
    
    }
    
    
    initializeFilters()
    {
        let $jsMapListFiltersButton = $('.js-wpetMapFiltersButton'),
            $body = $('body');
        
        $jsMapListFiltersButton.on('click', function(e) {
            e.preventDefault();
            $body.toggleClass('isWpetFiltersOpen');
        });
        
        $('.wpetFiltersOverlay, .js-wpetFiltersClose').on('click', function(e) {
            e.preventDefault();
            $body.removeClass('isWpetFiltersOpen');
        });
        
        $(document).on('wpet_ajax_build', function() {
            $body.removeClass('isWpetFiltersOpen');
        });
    }
    
}
